/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('SaleCure_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceSaleS = $resource(baseUrl + 'rest/saleCures/:id', {}, {
        query: {method: 'GET', isArray: true},
        get: {method: 'GET'}
    });
    return resourceSaleS;
}
]);

angular.module('FlexyBeautyApp.services').factory('SaleCure', ["SaleCure_Resource", "CureCategoryData", "CureData", "SaleCureData", "HumanResourceData", "CureItem", "TaxMode", "SaleItem", "CureCategory", "Cure",
    function (SaleCure_Resource, CureCategoryData, CureData, SaleCureData, HumanResourceData, CureItem, TaxMode, SaleItem, CureCategory, Cure) {
        //SaleCure inherit from Activity
        var SaleCure = function (saleCureRes, mustloadElements, isPreviousVersion) {
            SaleItem.call(this);

            //mustloadElements : boolean
            //isPreviousVersion : boolean (if the instance is a previous version -> do not add to active objects)
            this.id = null;
            this.label = null;
            this.price = 0;
            this.vat = null;
            this.vatCode = null;
            this.quantity = 0;
            this.originalPrice = 0;
            this.discountPercent = 0;
            this.cure = null;
            this.sale = null;
            this.humanResource;
            this.cureItems = [];
            this.version = null;

            this.loadObjectProperties(saleCureRes);
            if (mustloadElements)
                this.loadObjectCureItems(saleCureRes);
            this.loadRef();
            if (isPreviousVersion == undefined || !isPreviousVersion)//A previous version is not added to DATA
                SaleCureData.add(this);
        };

        SaleCure.prototype = Object.create(SaleItem.prototype);//inherit functions from SaleItem

        SaleCure.prototype.loadObjectProperties = function (object) {

            if (object !== undefined && object != null) {
                if (!this.id)
                    this.id = object.id;
                this.label = object.label;
                this.price = object.price;
                this.vat = object.vat;
                this.vatCode = object.vatCode;
                if (object.originalPrice !== undefined && object.originalPrice)
                    this.originalPrice = object.originalPrice;
                else
                    this.originalPrice = object.price;
                this.discountPercent = object.discountPercent;
                this.quantity = object.quantity;
                this.cureId = object.cureId;
                if (object.humanResourceId)
                    this.humanResource = HumanResourceData.getById(object.humanResourceId);
                if (object.version)
                    this.version = object.version;
            }
        };

        SaleCure.prototype.loadObjectCureItems = function (object) {

            if (object !== undefined && object != null) {
                this.cureItems = [];
                if (object.cureItems)
                    for (var i = 0; i < object.cureItems.length; i++)
                        this.cureItems.push(new CureItem(object.cureItems[i], this, true))
            }
        };

        SaleCure.prototype.loadRef = function () {
            if (this.cureId)
                this.cure = CureData.getById(this.cureId);
        };

        SaleCure.prototype.copyDataTo = function (object) {

            object.id = this.id;
            object.label = this.label;
            object.price = this.price;
            object.vat = this.vat;
            object.vatCode = this.vatCode;
            object.originalPrice = this.originalPrice;
            object.discountPercent = this.discountPercent;
            object.quantity = this.quantity;
            if (this.humanResource)
                object.humanResourceId = this.humanResource.id;

            if (this.cure)
                object.cureId = this.cure.id;
            else
                object.cureId = null;

            if (this.sale)
                object.saleId = this.sale.id;
            else
                object.saleId = null;
            object.cureItems = [];
            if (this.cureItems)
                for (var i = 0; i < this.cureItems.length; i++)
                    object.cureItems.push(this.cureItems[i].getObjectResource());

        };

        SaleCure.prototype.getObjectResource = function () {
            var saleCureRes = new SaleCure_Resource();
            this.copyDataTo(saleCureRes);
            return saleCureRes;
        };

        SaleCure.prototype.setIdUsingObject = function (object) {
            this.id = object.id;
        };

        SaleCure.prototype.setId = function (id) {
            this.id = id;
        };

        SaleCure.prototype.getId = function () {
            return this.id;
        };

        SaleCure.prototype.getLabel = function () {
            return this.label;
        };

        SaleCure.prototype.getPrice = function () {
            return this.price;
        };

        SaleCure.prototype.addCureItem = function (cureItem) {
            if (cureItem) {
                var index = this.cureItems.indexOf(cureItem);
                if (index == -1)
                    this.cureItems.push(cureItem);
                cureItem.saleCure = this;
            }
        };

        SaleCure.prototype.removeCureItem = function (cureItem) {
            if (cureItem != null) {
                var index = this.cureItems.indexOf(cureItem);
                if (index != -1)
                    this.cureItems.splice(index, 1);
                cureItem.saleCure = null;
            }

        };

        SaleCure.prototype.getCure = function () {
            return this.cure;
        };

        SaleCure.prototype.getItem = function () {
            return this.cure;
        };

        SaleCure.prototype.getItemCategoryType = function () {
            return CureCategory;
        };

        SaleCure.prototype.getItemType = function () {
            return Cure;
        };

        SaleCure.prototype.getDiscountPrice = function (taxMode) {
            var price = 0;
            if (this.sale.isStatusSoldOrCreditOrCanceled()) {
                price = this.price;
                //apply global discount on price
                if (this.sale.discountPercent != 0) {
                    price -= this.sale.discountPercent * price / 100;
                }

                if (taxMode === TaxMode.HT) {
                    var vat = this.vat ? this.vat : this.sale.vat;
                    price = price / (100 + vat) * 100;
                }
            }

            return price;
        };

        /**
         * @override SaleItem.prototype.getQuantity
         */
        SaleCure.prototype.getQuantity = function () {
            return this.quantity;
        };

        return SaleCure;
    }
]);

angular.module('FlexyBeautyApp.services').factory('SaleCureSrv', ["$log", "ServerSrv", "DayData", "SaleCureData", "SaleCure", "ActivitySrv", "SaleData",
    function ($log, ServerSrv, DayData, SaleCureData, SaleCure, ActivitySrv, SaleData) {
        var bpSrv = {};

        bpSrv.save = function (saleCure, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(bpSrv.saveSync, saleCure, successFunction, errorFunction);
        };
        bpSrv.saveSync = function (saleCure, successFunction, errorFunction) {

            var bsRes = saleCure.getObjectResource();
            bsRes.$save({}, //no params
                function (data) {
                    try {
                        // now we can set the id
                        saleCure.setId(data.id);
                        if (!saleCure.version || (data.version && data.version > saleCure.version))
                            saleCure.version = data.version;
                        if (successFunction != undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };
        bpSrv.updateLocally = function (id, resource) {
            var saleCure = SaleCureData.getById(id);

            if (saleCure && saleCure.version && resource.version && resource.version < saleCure.version)
                return null;

            if (saleCure != null) {
                saleCure.loadObjectProperties(resource);
                saleCure.id = id;
                saleCure.loadRef();
                //remove from sale
                if (saleCure.sale)
                    saleCure.sale.removeSaleCure(saleCure);
                if (resource.saleId) {
                    var sale = SaleData.getById(resource.saleId);
                    if (sale)
                        sale.addSaleCure(saleCure);
                }
            }

            return saleCure;
        };
        bpSrv.removeLocally = function (id, resource) {
            var saleCure = SaleCureData.getById(id)
            if (saleCure && saleCure.version && resource.version && resource.version < saleCure.version)
                return null;
            if (saleCure != null) {
                //remove from sale
                if (saleCure.sale)
                    saleCure.sale.removeSaleCure(saleCure);
            }
            return saleCure;
        };
        bpSrv.addLocally = function (id, resource) {
            var saleCure = SaleCureData.getById(id);
            if (saleCure && saleCure.version && resource.version && resource.version < saleCure.version)
                return null;
            if (saleCure != null) //check if resource already exist inside index (current action could be a 'cancel')
                saleCure.loadObjectProperties(resource);
            else {
                saleCure = new SaleCure(resource, null, false);
            }
            saleCure.id = id;
            //add to sale
            if (resource.saleId) {
                var sale = SaleData.getById(resource.saleId);
                if (sale)
                    sale.addSaleCure(saleCure);
            }

            return saleCure;
        };
        bpSrv.getPreviousVersionInstance = function (resource) {
            var saleCure = new SaleCure(resource, true);
            if (resource.saleId)
                saleCure.sale = SaleData.getById(resource.saleId);
            return saleCure;

        };

        return bpSrv;
    }
]);

angular.module('FlexyBeautyApp.services').factory('SaleCureData', ["$log", function ($log) {
    var saleCureData =
        {
            indexSaleCures: []
        };
    saleCureData.getById = function (saleCureId) {
        for (var i = 0; i < this.indexSaleCures.length; i++)
            if (this.indexSaleCures[i].id == saleCureId)
                return this.indexSaleCures[i];
        return null;
    }
    saleCureData.getIndexOf = function (saleCure) {
        if (saleCure)
            return this.indexSaleCures.indexOf(saleCure);
        return -1;
    }
    saleCureData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexSaleCures.length)
            return this.indexSaleCures[index];
        else
            return null;
    }
    saleCureData.add = function (saleCure) {
        this.indexSaleCures.push(saleCure);
        return this.indexSaleCures.length - 1;
    }
    saleCureData.clear = function () {
        saleCureData.indexSaleCures = [];
    }


    return saleCureData;
}]);



// WEBPACK FOOTER //
// ./js/services/models/SaleCure.js